async function alpakharzToursTicketConsent(params) {

    const cart = await (async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch('/cart.js');
                const data = await response.json();
                return resolve(data);
            } catch (error) {
                return reject(error);
            }
        })
    })();

    if (!cart) throw new Error('No cart available!')

    const popUpTemplate = (new DOMParser()).parseFromString(`
            <article>
                <section>
    
                    <h1>AlpakHARZ® Tours Tickets</h1>
                    <span>Du hast AlpakHARZ® Tours Tickets in deinem Warenkorb. Bitte bestätige dein Verständnis für dein Widerrufsrecht.</span>
                    
                    <label>
                        <input type="checkbox" name="checkbox" />
                        Ich stimme ausdrücklich zu, dass vor Ablauf der Widerrufsfrist mit der Ausführung des Vertrags begonnen wird.
                    </label>
    
                    <label>
                        <input type="checkbox" name="checkbox" />
                        Mir ist bekannt, dass mit Beginn der Ausführung mein Widerrufsrecht erlischt.
                    </label>
    
                    <button class="cart__checkout-button button">schließen</button>
    
                </section>
            </article>
    
        </div>
        `, 'text/html');

    const popUpHook = document.getElementById('alpakharz-tours-ticket-consent-popup')
    const agreeExpiry = popUpTemplate.firstElementChild.querySelectorAll('input')[0]
    const awareWithdrawal = popUpTemplate.firstElementChild.querySelectorAll('input')[1]
    const openPopUpButton = document.getElementById('alpakharz-tours-ticket-consent-popup-button');

    popUpTemplate.firstElementChild.querySelector('button').addEventListener('click', () => location.reload());

    const updateConsent = async (agreeExpiry, awareWithdrawal) => {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    'agree_expiry_of_withdrawal_period': agreeExpiry,
                    'aware_withdrawal_expires_at_execution': awareWithdrawal
                }
            })
        }).catch(() => console.error('Error saving consent!'));
    }

    const unset = () => {

        if (!cart.attributes['agree_expiry_of_withdrawal_period'] && !cart.attributes['aware_withdrawal_expires_at_execution']) return;

        agreeExpiry.value = false;
        agreeExpiry.checked = false;
        awareWithdrawal.value = false;
        awareWithdrawal.checked = false;

        updateConsent(agreeExpiry.checked, awareWithdrawal.checked).finally(() => location.reload())
    }

    const havingTourTickets = cart.items.find(item => item.product_type === 'Alpaka Tour');
    if (!havingTourTickets) return unset();

    const initCheckBoxes = () => {
        agreeExpiry.value = cart.attributes.agree_expiry_of_withdrawal_period === true;
        agreeExpiry.checked = cart.attributes.agree_expiry_of_withdrawal_period === true;
        awareWithdrawal.value = cart.attributes.aware_withdrawal_expires_at_execution === true;
        awareWithdrawal.checked = cart.attributes.aware_withdrawal_expires_at_execution === true;

        return true;
    }

    const installPopUp = () => {
        const isInstalled = popUpHook.children.length > 1;

        if (!isInstalled) popUpHook.appendChild(popUpTemplate.body.firstElementChild);

        return true;
    }

    const autoUnsetByHumanShortTermMemory = () => {
        const humanShortTermMemoryTime = 30 * 1000;
        setInterval(() => unset(), humanShortTermMemoryTime)
    }

    const autoUnsetByPageInvisibility = () => {
        document.addEventListener("visibilitychange", () => document.visibilityState === 'visible' && performance.getEntriesByType("visibility-state").filter( state => state.name === 'visible').length > 1 && unset());
    }

    agreeExpiry.addEventListener('change', () => updateConsent(agreeExpiry.checked, awareWithdrawal.checked));
    awareWithdrawal.addEventListener('change', () => updateConsent(agreeExpiry.checked, awareWithdrawal.checked));
    openPopUpButton?.addEventListener('click', async () => installPopUp() && initCheckBoxes());

    autoUnsetByHumanShortTermMemory();
    autoUnsetByPageInvisibility();
}

alpakharzToursTicketConsent();

